import api from '..';

export default (transportId) => {
  let url = `/tourclient/api/tour/filter/transport?`;

  if (transportId) {
    url += `transportId=${transportId?.value || transportId}&`;
  }
  url += `_=${Date.now()}`;
  return api.get(url, {
    id: `dictionary/transport/`,
    time: 0,
    formatting: true,
  });
};
